import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ContactInformationService from '../../cornucopia/contact-us/contact-information-service';

class UserCountrySelect extends Component {
  static propTypes = {
    userCountry: PropTypes.string.isRequired,
    onUserCountryChange: PropTypes.func.isRequired
  };

  handleOnChange = event => {
    this.props.onUserCountryChange(event.target.value);
  };

  renderOptions = () =>
    ContactInformationService.getCities().map(option => (
      <option key={option} value={option}>
        {trans(`city.${option}`)}
      </option>
    ));

  render() {
    return (
      <fieldset className="contact-us__wrapper">
        <legend>{trans('contact_us.user_country.legend')}</legend>
        <div className="contact-us__select">
          <select value={this.props.userCountry} onChange={this.handleOnChange}>
            <option value="" disabled>
              {trans('contact_us.user_country.city')}
            </option>
            {this.renderOptions()}
          </select>
        </div>
      </fieldset>
    );
  }
}

export default UserCountrySelect;
